import React from 'react';
import moment from 'moment';
import { Grid, Typography } from '@material-ui/core';

export default function SessionClose({ data }) {
  const { userName, createdAt } = data;

  return(
    <Grid container>
      <Grid xs={12}>
        <Typography color='primary'>
          <b>{userName}</b> encerrou a sessão em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b>
        </Typography>
      </Grid>
    </Grid>
  );
}